import React, { FC, useId } from 'react'

import { WithClassName } from 'common/types'

export const TipSvg: FC<{} & WithClassName> = ({ className }) => {
  const id = useId()

  return (
    <svg
      className={className}
      width="30"
      height="18"
      viewBox="0 0 30 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${id})`}>
        <path
          d="M15 18C15 12 9.8 6 2 6H28C20.2 6 15 12 15 18Z"
          fill="#FC6ABD"
          fillOpacity="0.32"
        />
        <path
          d="M15 8C18.3 2.66695 23.8863 2 26 2L26 0L4 -5.7699e-06L4 2C6.11372 2 11.15 2.66695 15 8Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect
            width="30"
            height="18"
            fill="white"
            transform="translate(30 18) rotate(-180)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
